<i18n src="@/locales/models/delivery_product.yml" lang="yaml"></i18n>

<i18n
  src="@/locales/views/service_provider/delivery/managing/show_process.yml"
  lang="yaml"
></i18n>
<template>

  <div class="mt-8">
  <alert-danger :errors_data="std_err" />
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.delivery_products_title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-6">
          <div
            v-for="delivery_product in delivery_products"
            class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            :key="delivery_product.id"
          >
            <div class="sm:col-span-2">
              <div class="mt-1">
                {{ delivery_product.crop.name }}
              </div>
            </div>

            <div class="sm:col-span-2">
              <div class="mt-1">
                <input
                  type="number"
                  v-model.number="delivery_product.base_price"
                  :class="['input-text', isInvalid('base_price')]"
                />
              </div>
            </div>
            <div class="flex sm:col-span-2 align-middle justify-around">
              <success-button
                v-if="!delivery_product.proc_save_button"
                @click.prevent="update(delivery_product)"
                :label="$t('labels.update_button')"
              />
              <success-button-processing
                v-else
                :label="$t('labels.update_button')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/service_provider/requesters/delivery/managing/manage_delivery_products.js";
export default {
  name: "SPDeliveryDistributionEditOrder",
  components: {},
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      delivery_products: [],
    };
  },
  props: {
    service_provider_id: { required: true },
    delivery_process_id: { required: true },
  },
  created() {
    this.fetchDeliveryProducts();
  },
  methods: {
    fetchDeliveryProducts: async function () {
      const response = await Requester.fetchDeliveryProducts(
        this.service_provider_id,
        this.delivery_process_id
      );

      this.delivery_products = response.data;
      this.delivery_products.forEach((product) => {
        product.name = product.crop.name;
      });
    },

    update: async function (delivery_product) {
      this.proc_save_button = true;
      try {
        let response = await Requester.update(
          this.service_provider_id,
          this.delivery_process_id,
          delivery_product.id,
          delivery_product
        );

        this.registerSuccessNotification({
          title: response.data.success_message,
        });
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
        this.proc_save_button = false;
      }
    },
  },
};
</script>
